<script>
  import FilterItem from "./FilterItem.svelte";
  import {M} from "../external";

  export let renderFilters, onClick, onDelete, onDeleteRow, onAddFilterClick, row;
  let instance;
</script>
<style>
    .remove-row {
        color: #fff;
        cursor: pointer;
        float: left;
        margin: 8px;
        font-size: 19px;
    }
</style>
<div class="f-left mb-5 relative mobile-filter">

    <div class="f-left" data-role="filter-list" bind:this={instance}>
        {#if row !== 0}
            <i class="material-icons rounded-effect remove-row" on:click={e => onDeleteRow(e, row)}>delete_outline </i>
        {/if}
        {#if renderFilters && renderFilters.length > 0}
            {#each renderFilters as filter, idx (filter)}
                <FilterItem data={filter} onClick={e => onClick(e, row, idx)}
                            onDeleteClick={e => onDelete(e, row, idx)}/>
            {/each}
        {/if}
    </div>
    <a on:click={() => onAddFilterClick(instance, row)} class="filter-option add-filter">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             width="10px" height="10px" viewBox="0 0 357 357" style="enable-background:new 0 0 357 357;"
             xml:space="preserve">
              <path d="M357,204H204v153h-51V204H0v-51h153V0h51v153h153V204z"/>
            </svg>
        {M.ADD_FILTER}
    </a>
</div>